<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>工单系统</el-breadcrumb-item>
            <el-breadcrumb-item>服务窗口设置</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
            <el-row style="text-align:left">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-select filterable v-model="searchForm.OrderServiceWinID" clearable size="small">
                <el-option
                  v-for="(item,index) in winOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="GetServiceWinList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="initAddServiceWin" plain>添加服务窗口</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-table
            :data="serviceWinList"
            style="width: 100%"
            row-key="ID"
            v-loading="loading"
            size="small"
          >
            <el-table-column prop="ServiceName" label="服务窗口名称"></el-table-column>
            <el-table-column prop="SimpleDescribe" label="简述"></el-table-column>
            <el-table-column prop="DealPersonName" label="处理人"></el-table-column>
            <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
            <el-table-column label="操作" >
              <template slot-scope="scope">
                <el-button type="text" @click="initEditServiceWin(scope.row)" size="small">编辑</el-button>
                <el-popconfirm title="确定删除此条信息吗？" @onConfirm="DeleteWin(scope.row)">
                  <el-button type="text" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
 
      </el-row>
      <el-dialog :title="dialogTitle" :visible.sync="ServiceWinVisible">
        <el-form :model="serviceWin" ref="serviceWinForm" :rules="serviceWinRules">
          <el-form-item label="服务窗口名称" :label-width="formLabelWidth" prop="ServiceName">
            <el-input size="small" v-model="serviceWin.ServiceName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="处理人" :label-width="formLabelWidth" prop="DealPersonName">
            <el-input
              size="small"
              v-model="serviceWin.DealPersonName"
              @focus="dialogSelectMemberVisible=true"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="简述" :label-width="formLabelWidth" prop="SimpleDescribe">
            <el-input
              size="small"
              type="textarea"
              :rows="3"
              v-model="serviceWin.SimpleDescribe"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="Note">
            <el-input
              size="small"
              type="textarea"
              :rows="3"
              v-model="serviceWin.Note"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="OperOrderServiceWin">保存</el-button>
          <el-button size="small" @click="ServiceWinVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog width="50%" title="选择人员" :visible.sync="dialogSelectMemberVisible">
        <selectMember @ConfirmeValue="confirmSelect"></selectMember>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click=" dialogSelectMemberVisible = false">确认</el-button>
          <el-button @click="dialogSelectMemberVisible = false">取消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  GetOrderSerivceWin,
  OrderServiceWinAdd,
  UpdateServiceWin,
  DeleteServiceWin,
  GetOrderServiceWinPage
} from "../../until/ZeusApiSDK/Logic/OrderServiceLogic";
import {
  GetCurrentUserInfo,
  GetGuid,
  getNowDateStr
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
import { GetUserByName } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import selectMember from "../Structure/SelectMember";
export default {
  data() {
    return {
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      serviceWinList: [],
      ServiceWinVisible: false,
      formLabelWidth: "150px",
      serviceWin: {},
      dialogTitle: "",
      activeNames:"",
      searchForm:{OrderServiceWinID:""},
      serviceWinRules: {
        //用户验证规则
        ServiceName: [
          { required: true, message: "请输入服务窗口名称", trigger: "blur" }
        ],
        SimpleDescribe: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ]
      },
      dialogSelectMemberVisible: false,
      winOptions:[]
    };
  },
  created() {
    this.currentUser = GetCurrentUserInfo();
    this.GetServiceWinList();
    this.GetServiceWinOptions();
  },
  methods: {
    //更改每页显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetServiceWinList();
    },
    //翻页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetServiceWinList();
    },
        GetServiceWinOptions: function() {
      GetOrderSerivceWin().then(res => {
        if (res) {
          for (let r of res) {
            var option = { value: r.ID, label: r.ServiceName };
            this.winOptions.push(option);
          }
        }
      });
    },
    GetServiceWinList: function() {
      this.loading = true;
      GetOrderServiceWinPage(this.searchForm.OrderServiceWinID,this.pageIndex,this.pageSize).then(res => {
        this.serviceWinList = res.List;
        this.totalCount=res.TotalCount;
        for (let s of this.serviceWinList) {
          var dealers = JSON.parse(s.DealPerson);
          var dnames = [];
          for (let d of dealers) {
            dnames.push(d.name);
          }
          s.DealPersonName = dnames.join(",");
        }
        this.loading = false;
      });
    },
    //刷新
    Refresh:function(){
      this.GetServiceWinList();
    },
    initAddServiceWin: function() {
      this.serviceWin = {};
      this.ServiceWinVisible = true;
      this.dialogTitle = "添加服务窗口";
    },
    initEditServiceWin: function(row) {
      this.serviceWin = row;
      this.ServiceWinVisible = true;
      this.dialogTitle = "编辑服务窗口";
    },
    OperOrderServiceWin: function() {
      if (this.serviceWin.ID) {
        UpdateServiceWin(this.serviceWin).then(res => {
          if (res == "success") {
            this.$message({
              message: "编辑成功",
              type: "success",
              center: true
            });
            this.ServiceWinVisible = false;
            this.GetServiceWinList();
          } else {
            this.$message({
              message: "编辑失败",
              type: "warning",
              center: true
            });
          }
        });
      } else {
        GetGuid().then(id => {
          this.serviceWin.ID = id;
          this.serviceWin.IsDelete = 0;
          this.serviceWin.CreateTime = getNowDateStr();
          OrderServiceWinAdd(this.serviceWin).then(res => {
            if (res == "success") {
              this.$message({
                message: "删除成功",
                type: "success",
                center: true
              });
              this.ServiceWinVisible = false;
              this.GetServiceWinList();
            } else {
              this.$message({
                message: "删除失败",
                type: "warning",
                center: true
              });
            }
          });
        });
      }
    },
    DeleteWin: function(row) {
      var ids = row.ID;
      DeleteServiceWin(ids).then(res => {
        if (res == "success") {
          this.$message({
            message: "添加成功",
            type: "success",
            center: true
          });
          this.GetServiceWinList();
        } else {
          this.$message({
            message: "添加失败",
            type: "warning",
            center: true
          });
        }
      });
    },
    confirmSelect: function(data) {
      if (data.length > 0) {
        var dealerArr = [];
        var nameArr = [];
        data.forEach(element => {
          var userNameArr = element.username.split("@");
          var dealer = {
            name: element.label,
            id: element.key,
            EntID: userNameArr[0]
          };
          dealerArr.push(dealer);
          nameArr.push(element.label);
        });
        this.serviceWin.DealPerson = JSON.stringify(dealerArr);
        this.serviceWin.DealPersonName = nameArr.join(",");
      } else {
        this.serviceWin.DealPerson = "";
        this.serviceWin.DealPersonName = "";
      }
    }
  },
  components: { selectMember }
};
</script>
